
import { getParams } from '~/plugins/product'

export default {
  name: 'ProductExerptList',
  props: {
    products: {
      type: Array,
      required: true
    }
  },
  methods: { getParams }
}
